import { render, staticRenderFns } from "./modal-add-brand.vue?vue&type=template&id=5ec1acb3&"
import script from "./modal-add-brand.vue?vue&type=script&lang=js&"
export * from "./modal-add-brand.vue?vue&type=script&lang=js&"
import style0 from "./modal-add-brand.vue?vue&type=style&index=0&id=5ec1acb3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports